export interface Medication {
	id: number;
	handle: string | null;
	description: string | null;
	origNdcNumber: string | null;
	rawNdcNumber: string | null;
	altNdcNumber: string | null;
	schedule: string | null;
	lastUnitNumber: number | null;
	dataAdded: number | null;
	activeStatus: string | null;
	daysSupply: string | null;
	packageSize: number | null;
	awp: string | null;
	medicationFamilyId: number;
	containerURL: string;
	tabletURL: string;
	manufacturedById: number;
	manufacturedForId: number;
	storageInstructions: string;
	ingredients: string;
	containerImagePresent: boolean;
	tabletImagePresent: boolean;
	medicationFamilyName: string;
	ndcFormat: any;
	lastCost: number;
}


export class Medication {

}
